export enum DepartmentPermissionsType {
    NEW = "new",
    EDIT = "edit",
    VIEW = "view"
}
